import * as Yup from 'yup';

export const ChangePasswordValidationSchema = Yup.object().shape({
  password: Yup.string().trim().required('O campo Senha é obrigatório.'),
  confirmPassword: Yup.string()
    .trim()
    .required('O campo Confirme sua senha é obrigatório.')
    .oneOf([Yup.ref('password'), null], 'As senhas precisam ser iguais.'),
});
